import script from "./PdbeCom.vue?vue&type=script&setup=true&lang=js"
export * from "./PdbeCom.vue?vue&type=script&setup=true&lang=js"

import "./PdbeCom.vue?vue&type=style&index=0&id=7582c206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7582c206"]])

export default __exports__